import { render } from "./mensagens.vue?vue&type=template&id=45d704a6"
import script from "./mensagens.vue?vue&type=script&lang=js"
export * from "./mensagens.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__